import React from "react"

class CauseSel extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputClicked = this.handleInputClicked.bind(this)
    this.handleInputChanged = this.handleInputChanged.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleInputClicked(){
    let model = this.props.model
    let filters = model.filters
    filters.orgs.causes_on = !filters.orgs.causes_on
    filters.sort_by.on = false
    filters.departments.on = false
    filters.details.on = false
    filters.themes.on = false
    filters.orgs.on = false
    if(!filters.orgs.causes_on){
      filters.orgs.causes_query = ""
    }
    this.props.changeState(model)
  }

  handleInputChanged(event){
    let v = event.currentTarget.value.trim()
    let model = this.props.model
    model.filters.orgs.causes_query = v
    if(!_.isEmpty(v)){
      model.filters.orgs.causes_on = true
    }
    this.props.changeState(model)
  }

  handleSelect({event, item}){
    let model = this.props.model
    let selected = model.filters.orgs.selected
    selected.causes[item] = !selected.causes[item]
    model.filters.pagination.page = 1
    this.props.changeState(model)
    this.props.search({})
  }

  render(){
    const self = this
    let list = []
    const model = self.props.model
    const filters = model.filters
    const results = model.results.results

    if(results){
      let groups = results.groups
      if(groups && groups.cause){
        for(const name in groups.cause){
          if(name.toLowerCase().includes((filters.orgs.causes_query || '').toLowerCase())){
            const count = groups.cause[name]
            list.push(
              <div key={name} className="ic-item grid-x grid-padding-x"
                onClick={(e) => { self.handleSelect({event: e, item: name}) }}>
                <div className="cell small-2 text-right">
                  <i className={`ic-check fal ${filters.orgs.selected.causes[name] ? 'fa-check-square' : 'fa-square'}`}></i>
                </div>
                <div className="cell small-8">
                  {name}
                </div>
                <div className="cell small-2">
                  ({count})
                </div>
              </div>
            )
          }
        }
      }
    }

    return (
      <React.Fragment>
        <div className="filter-title">
          Cause
        </div>
        <div className="search-sel-wrapper">
          <div className="input-list-wrapper" onClick={self.handleInputClicked}>
            <input className="input-list" type="text" value={filters.orgs.causes_query || ''} onChange={self.handleInputChanged} placeholder="Causes" style={{borderRadius: 0}} />
            <i className="ico-search fal fa-search"></i>
            <i className={`ico-down fal fa-chevron-${filters.orgs.causes_on ? 'up' : 'down'}`}></i>
          </div>
          <div className={`${filters.orgs.causes_on ? 'shown' : 'hidden'}`}>
            <div className="indent-list">
              {list}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default CauseSel
